import { isDate as isDate$1 } from '../../predicate/isDate.mjs';

function isDate(value) {
    return isDate$1(value);
}

export { isDate };
